import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { login } from '../../api/services/authService';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';
import { emailError } from '../../utils/validation';
import AuthLayout from './AuthLayout';
import { AuthField, PasswordField } from './AuthField';

function noticeFor(state) {
  if (state?.joined) return `Account created — you've joined ${state.joined}. Please sign in.`;
  if (state?.registered) return 'Account created. Please sign in.';
  if (state?.verified) return 'Email verified. Please sign in.';
  if (state?.reset) return 'Password updated. Please sign in with your new password.';
  if (state?.deactivated) return 'Your account has been deactivated.';
  return '';
}

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { applySession } = useWorkspace();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [notice] = useState(noticeFor(location.state));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (emailError(email)) return setError(emailError(email));
    if (!password) return setError('Password is required');
    setLoading(true);
    try {
      const session = await login(email.trim(), password);
      setSuccess(true);
      setTimeout(() => { applySession(session); navigate('/dashboard', { replace: true }); }, 500);
    } catch (err) {
      if (err.code === 'EMAIL_NOT_VERIFIED') {
        navigate('/verify-email', { state: { email: email.trim().toLowerCase(), needsCode: true } });
        return;
      }
      setError(err.message || 'Unable to sign in. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Welcome Back"
      subtitle="Login to your account to continue"
      footer={<>Don't have an account? <Link to="/signup">Sign Up</Link></>}
    >
      {notice && <div className="auth-success auth-notice" role="status">{notice}</div>}
      {success ? <div className="auth-success" role="status">Login successful!</div> : (
        <form onSubmit={handleSubmit} noValidate>
          <AuthField label="Email address" icon="bi-envelope" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" autoComplete="email" />
          <PasswordField value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" />
          <div className="auth-actions"><button type="button" className="auth-link" onClick={() => navigate('/forgot-password')}>Forgot Password?</button></div>
          {error && <div className="auth-error" role="alert">{error}</div>}
          <button className="auth-primary" disabled={loading} type="submit">{loading ? 'Signing in…' : 'Login'}</button>
        </form>
      )}
    </AuthLayout>
  );
}

export default Login;
